    export function initFaqCategoryNav() {
        var nav = document.querySelector(".faq-category-nav");

        if (!nav) {
            return;
        }

        var selectedLink = nav.querySelector(".faq-category-nav__link--is-selected");

        if (!selectedLink) {
            return;
        }

        selectedLink.scrollIntoView({ block: "nearest", inline: "center" });
    }
